<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <!-- <Toast style="margin-top: 35px" /> -->
      <form>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-6 p-lg-4 p-xl-2">
            <label for="purchaseSalesDate">Transfer Date</label>
            <date-picker ref="tran" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" ref="tran" type="text" v-else class="nepali-calendar" id="purchaseSalesDate"
                        v-model="purchaseSalesDate"/>
          </div>
          <div class="p-field p-col-12 p-md-6 p-lg-4 p-xl-2">
            <label for="orderNo">Transfer No</label>
            <InputText id="orderNo" disabled v-model="orderNo"/>
          </div>
          <div class="p-col-12 p-xl-7 p-grid">
            <div class="p-field p-col-9 p-lg-4">
              <label for="warehouse">Transfer From</label>
              <Dropdown
                v-if="!setWarehouseData"
                v-model="warehouseIdFrom"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select warehouse"
                :showClear="true"
              />
              <Dropdown
                v-if="setWarehouseData"
                v-model="warehouseIdFrom"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select warehouse"
                :disabled="true"
              />
            </div>
            <div class="p-field p-col-3 p-lg-2 align-self-end">
              <wearhouseDialog class="" v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
            </div>
            <div class="p-field p-col-12 p-lg-4">
              <label for="shipDate">Transfer To</label>
              <Dropdown
                v-model="warehouseIdTo"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select warehouse"
                :showClear="true"
              />
            </div>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-lg-4 p-grid">
            <div class="p-col-8">
              <label for="item">Item<b style="color:red;">*</b></label>
              <AutoComplete v-model="items" filterMatchMode='contains'
                            :suggestions="filteredItems" @complete="searchItem($event)"
                            field="name" ref="itm">
              </AutoComplete>
            </div>
            <div class="align-self-end p-col-4">
              <itemDialog class="" v-tooltip.top="'Add Item'"
                          @set_data_item="set_data_item"/>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-3 p-lg-1">
            <label for="quantity">Qty</label>
            <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="quantity" v-model="quantity" /> -->
            <InputNumber id="minmaxfraction" onfocus="if (this.value === '0.00'){this.value = ''
}" v-model="quantity" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-md-3 p-lg-1">
            <label for="qty">Unit</label>
            <InputText v-model="items.unitName" disabled/>
          </div>
          <div class="p-field p-col-12 p-md-3 p-lg-2">
            <label for="rate">Rate</label>
            <!-- <input type="text" class="form-control" @keypress="isNumber(event)" id="rate" v-model="rate" /> -->
            <InputNumber id="minmaxfraction" onfocus="if (this.value === '0.00'){this.value = ''
}" v-model="rate" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-12 p-md-3 p-lg-2">
            <label for="total">Total</label>
            <!-- <input  class="form-control" id="total" @keypress="isNumber(event)" v-model="total"/> -->
            <InputNumber disabled id="minmaxfraction" onfocus="if (this.value === '0.00'){this.value = ''
}" v-model="total" :minFractionDigits="2" :maxFracionDigits="4"/>
          </div>
          <div class="p-field p-col-6 p-offset-6 p-lg-offset-9 p-lg-3">
            <div class="p-fluid p-formgrid p-grid justify-content-end">
              <div class="p-field p-col-6 p-lg-6">
                <Button class="p-button-raised" @click.prevent="addItemToDTO"
                        :label="!editDTO?'Add':'Update'"/>
              </div>
              <div class="p-field p-col-6 p-lg-6" v-if="editDTO">
                <Button class="p-button-raised p-button-danger"
                        @click="itemDTOreset"
                        label="Cancel"/>
              </div>
            </div>
          </div>
        </div>

        <div style="display:none">{{ totalAmount }}{{ findRate }}{{ setRateFromItem }}</div>
        <div class="p-field p-col-12 p-md-2" v-if="items.closingStock >= 0">
          <label for="avlQty">Cur. Stock</label>
          <span>{{ items.closingStock }}</span>
        </div>
      </form>
      <div class="p-field p-col-12 p-md-12 genTable">
        <div class="p-datatable-responsive p-datatable-gridlines">
          <div class="scrollable">
            <table class="table table-bordered ">
              <thead>
              <tr>
                <th>SN</th>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Rate</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in inventoryInOutDetailList " :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.itemMaster.name }}</td>
                <td style="text-align:right">{{ item.quantity }}</td>
                <td style="text-align:right">{{ item.rate }}</td>
                <td style="text-align:right">{{ item.rate * item.quantity }}</td>
                <td style="text-align:center">
                  <Button class="p-button-raised p-button-rounded p-button-success"
                          @click="editItemFromDTO(item, index)" icon="pi pi-pencil"/>
                  <Button class="p-button-raised p-button-rounded p-button-danger" v-if="editDTO" icon="pi pi-trash"
                          @click="deleteItemFromDTO(item, index)" disabled/>
                  <Button class="p-button-raised p-button-rounded p-button-danger" v-else-if="!editDTO"
                          icon="pi pi-trash"
                          @click="deleteItemFromDTO(item, index)"/>
                </td>
              </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2">Total:</td>
                  <td>{{ totalQty }}</td>
                  <td colspan="1">&nbsp;</td>
                  <td>{{ subTotal }}</td>
                  <td>&nbsp;</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <!-- <div class="p-fluid p-formgrid p-grid p-mt-2 totalCount">
            <div class="p-field p-col-12 p-md-2">
              <b class="totalTitle">Total:</b>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <b class="totalQuantity">{{ totalQty }}</b>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <b class="totalSubtotal">{{ subTotal }}</b>
            </div>
          </div> -->
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid p-mt-2">
        <div class="p-field p-col-12 p-lg-4 p-xl-3">
          <label>Narration</label>
          <Textarea rows="6" v-model="narration"/>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-6 p-md-4 p-xl-2 p-xl-offset-2">
          <Button icon="pi pi-save" class="p-button-raised p-button-success"
                  @click.prevent="saveSalesOrder" :label="!editing?'Save':'Update'"/>
        </div>
        <div class="p-field p-col-6 p-md-2">
          <Button class="p-button-raised p-button-warning" @click="reset"
                  v-if="stockTransferInternal==undefined" label="Reset" icon="pi pi-refresh"/>
        </div>
        <div class="p-field p-col-6 p-md-2" v-if="stockTransferInternal != undefined">
          <Button class="p-button-raised p-button-danger"
                  @click="goBack()" label="Cancel"/>
        </div>
        <div class="p-field p-col-6 p-md-2">
          <Button class="p-button-raised p-button-info" v-if="saved" label="Print"
                  icon="pi pi-print"/>
          <Button class="p-button-raised p-button-info" v-else label="Print" icon="pi pi-print"
                  disabled/>
        </div>
        <div class="p-field p-col-6 p-md-4 p-xl-2">
          <Button class="p-button-raised p-button-secondary"
                  label="Generate PDF" icon="pi pi-download" v-if="saved"/>
          <Button class="p-button-raised p-button-secondary"
                  label="Generate PDF" icon="pi pi-download" disabled v-else/>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
// import Toast from 'primevue/toast'
import InputMask from 'primevue/inputmask'
import customerDialog from '../accountDialog/CustomerAccountDialog'
import wearhouseDialog from '../warehouseDialog/warehouseDialog'
import itemDialog from '../itemDialog/itemMasterDialog'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import InputText from 'primevue/inputtext'

export default {
  name: 'stockTransferInternal',
  props: ['stockTransferInternal'],
  data() {
    return {
      warehouseIdFrom: '',
      warehouseIdTo: '',
      items: '',
      referenceNumber: '',
      englishDateEnabled: true,
      quantity: 0,
      orderMessage: '',
      rate: 0,
      purchaseSalesDate: null,
      shipDate: null,
      inventoryInOutDetailList: [],
      inventoryInOutDetailDeleteList: [],
      editDTO: false,
      editing: false,
      inventoryOutheaderId: null,
      index: null,
      orderNo: null,
      loading: false,
      id: null,
      totalQty: '',
      total: 0,
      filteredItems: null,
      saved: false,
      narration: '',
      setWarehouseData: false
    }
  },
  computed: {
    totalBillAmount() {
      return parseFloat(this.quantity) * parseFloat(this.rate)
    },
    // orderNo() {
    //   return this.$store.state.sales.maxSalesOrderNumber
    // },
    // narration() {
    //   if (this.salesOrder === undefined) {
    //     return this.orderMessage + ' ' + this.orderNo
    //   } else {
    //     return this.orderMessage
    //   }
    // },
    totalAmount() {
      if (this.quantity > 0 && this.rate > 0) {
        let totalAmt = 0
        totalAmt = parseFloat(this.quantity) * parseFloat(this.rate)
        if (isNaN(totalAmt)) {
          totalAmt = 0
        }
        this.total = totalAmt
        return totalAmt
      }
    },
    findRate() {
      if (this.total > 0 && this.quantity > 0) {
        let rate = 0
        rate = parseFloat(this.total) / parseFloat(this.quantity)
        if (isNaN(rate)) {
          rate = 0
        }
        this.rate = rate
        return rate
      }
    },
    setRateFromItem() {
      if (!this.editDTO) {
        let rate = 0
        this.rate = this.items.purchaseRate
        return rate
      }
    },
    subTotal() {
      let subTotal = 0
      this.taxable = 0
      this.tax = 0
      this.nonTaxable = 0
      this.totalQty = 0
      for (let i = 0; i < this.inventoryInOutDetailList.length; i++) {
        subTotal += (parseFloat(this.inventoryInOutDetailList[i].rate) * parseFloat(this.inventoryInOutDetailList[i].quantity))
        this.itemSelected = this.inventoryInOutDetailList[i].itemMaster
        this.totalQty += this.inventoryInOutDetailList[i].quantity
      }
      return subTotal.toFixed(4)
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    supplierAndCustomerList() {
      return this.$store.state.accountMaster.supplierAndCustomerList
    },
    itemMasterListByItemType() {
      return this.$store.state.itemMaster.itemMasterListByItemType
    }
  },
  mounted() {
    this.warehouseList()
    this.supplierCustomerList()
    this.itemMasterListByItemTypes()
    this.maxSalesOrderNo()
    if (this.stockTransferInternal !== undefined) {
      this.editStockTransfor()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.stockTransferInternal === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.setWarehouse()
  },
  methods: {
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async supplierCustomerList() {
      await this.$store.dispatch('loadsupplierAndCustomerList')
    },
    async itemMasterListByItemTypes() {
      await this.$store.dispatch('loadItemMasterListByItemTypeSales')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseIdFrom = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseIdFrom = this.warehouseLists[0]
      }
    },
    async maxSalesOrderNo() {
      let response = await this.$store.dispatch('maxTransforNo')
      if (this.stockTransferInternal === undefined) {
        this.orderNo = response.data.data
        this.orderMessage = response.data.message
        this.narration = response.data.message + '- ' + response.data.data
      } else {
        this.orderNo = this.stockTransferInternal.transforNo
        this.orderMessage = this.stockTransferInternal.remarks
      }
    },
    addItemToDTO() {
      let item = {
        itemId: this.items.id,
        itemMaster: this.items,
        quantity: this.quantity,
        rate: this.rate,
        id: this.id
      }
      if (this.warehouseIdFrom === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store from!', life: 10000})
        return
      }
      if (this.warehouseIdTo === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store To!', life: 10000})
        return
      }
      if (this.items.id === undefined) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Invalid item!', life: 10000})
        return
      }
      if (this.items === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select at least one Item!', life: 10000})
        return
      } else if (this.quantity <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Quantity must be greater than 0!', life: 10000})
        return
      } else if (this.rate <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Rate must be greater than 0!', life: 10000})
        return
      } else {
        if (!this.editDTO) {
          this.inventoryInOutDetailList.push({...item})
        } else {
          this.inventoryInOutDetailList.splice(this.index, 1, {...item})
        }
      }
      this.itemDTOreset()
      this.focusInput()
    },
    editItemFromDTO(data, index) {
      this.itemDTOreset()
      this.editDTO = true
      this.items = data.itemMaster
      this.index = index
      this.total = (parseFloat(this.rate) * parseFloat(this.quantity)).toFixed(2)
      this.rate = data.rate
      this.quantity = data.quantity
      if (data.id !== undefined) {
        this.id = data.id
      }
    },
    async saveSalesOrder() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 10000})
        return
      }
      let response = ''
      let stockTransferInternal = {
        transforNo: this.orderNo,
        warehouseFromId: this.warehouseIdFrom.id,
        warehouseToId: this.warehouseIdTo.id,
        transforDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        referenceNumber: this.referenceNumber,
        fyId: this.$store.state.fyId,
        remarks: this.narration,
        id: this.inventoryOutheaderId,
        stockTransforDetailsDTOList: this.inventoryInOutDetailList,
        stockTransforDetailsDeleteDTOList: this.inventoryInOutDetailDeleteList
      }
      // console.log
      // // debugger
      if (this.warehouseIdFrom === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store from!', life: 10000})
        return
      }
      if (this.warehouseIdTo === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store to!', life: 10000})
        return
      }
      if (stockTransferInternal.stockTransforDetailsDTOList.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please add at least one item!', life: 10000})
        return
      }
      if (this.stockTransferInternal === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addStockTransforInternal', stockTransferInternal)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateStockTransforInternal', stockTransferInternal)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.setWarehouse()
        await this.maxSalesOrderNo()
        this.reset()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    set_data_warehouse(data) {
      this.warehouseIdFrom = data
    },
    set_data_item(data) {
      this.items = data
    },
    editStockTransfor() {
      this.editing = true
      // this.purchaseSalesDate = this.salesOrder.purchaseSalesDate
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.stockTransferInternal.transforDateNepali
      } else {
        this.purchaseSalesDate = this.stockTransferInternal.transforDate
      }
      this.referenceNumber = this.stockTransferInternal.referenceNumber
      this.narration = this.stockTransferInternal.remarks
      this.warehouseIdFrom = this.stockTransferInternal.warehouseFromDTO
      this.warehouseIdTo = this.stockTransferInternal.warehouseToDTO
      this.inventoryOutheaderId = this.stockTransferInternal.id
      this.inventoryInOutDetailList = this.stockTransferInternal.stockTransforDetailsDTOList
    },
    deleteItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    setNepaliDate() {
      if (this.stockTransferInternal === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    itemDTOreset() {
      this.items = ''
      this.rate = 0
      this.quantity = 0
      this.total = 0
      this.editDTO = false
      this.id = null
    },
    reset() {
      this.itemDTOreset()
      this.warehouseIdFrom = ''
      this.warehouseIdTo = ''
      this.referenceNumber = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
      this.inventoryInOutDetailList = []
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
    },
    searchItem(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredItems = [...this.itemMasterListByItemType]
        } else {
          this.filteredItems = this.itemMasterListByItemType.filter((item) => {
            return item.name.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },
    focusInput() {
      this.$refs.itm.focus()
    },
    focusAfterSave() {
      this.$refs.tran.focus()
    },
    goBack() {
      if (this.inventoryInOutDetailDeleteList.length > 0) {
        this.stockTransferInternal.inventoryInOutDetailList = this.inventoryInOutDetailDeleteList
      }
      this.$router.back()
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    Button,
    Textarea,
    InputText,
    InputMask,
    customerDialog,
    wearhouseDialog,
    itemDialog
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// stockTransferInternal.vue?28dbdcc2